export interface IEnvironment {
  production: boolean;
  apiUrl: string;
  merakiApiGateway: string;
  merakiCacheLoadBalancer: string;
  applicationInsightsKey: string;
  clientId: string;
  videoChatUrl: string;
  googleCaptchaSiteKey: string;
  oneSignalAppId: string;
  bridgeitUrl: string;
  experimentsAppUrl: string;
  practiceAgent: {
    baseUrl: string;
    environment: string;
    practiceAgentLink: string;
  };
  meiliSearchLookup: {
    host: string;
    key: string;
  };
  meiliSearchPatientLookup: {
    host: string;
    key: string;
  };
  meiliSearchAccount: {
    host: string;
    key: string;
  };
  algoliaSettings: {
    apiKey: string;
    appId: string;
    medicineIndexName: string;
    genericMedicineIndexName: string;
    diagnosisIndexName: string;
    defaultDebounce: number;
  };
  smartGenericsSettings: {
    Url: string;
    FsCollection: string;
    BaseGroupName: string;
    CommunityName: string;
    AdsDisplayUrl: string;
  };
  settings?: { [key: string]: boolean };
  offlineSync: {
    enabled: boolean;
    delayBeforeStart: number;
    delayBetweenPatients: number;
    delayBetweenChecks: number;
  };
  keepAliveTesting: {
    enabled: boolean;
    delayBetweenChecks: number;
  };
  localStorage: {
    type: StorageType;
    version: number;
  };
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  noraV2: {
    noraApiBaseUrl: string;
    noraModuleUrl: string;
    noraAccountUrl: string;
  };
  sandbox: {
    cloudFunctionBaseUrl: string;
    clinicalaiClinicalInsightsFunctionUrl: string;
    clinicalaiLettersGenerationFunctionUrl: string;
  };
  streamingSpeechServer?: {
    url: string;
    healthUrl: string;
  };
}

export enum StorageType {
  LocalStorage = 'LOCALSTORAGE',
  IndexedDB = 'INDEXEDDB',
}
